export class VersionMismatchError extends Error {
  constructor(targetVersion: string, packageVersions: Record<string, string>) {
    // Identify packages with mismatched versions
    const affectedPackages = Object.entries(packageVersions)
      .filter(([, v]) => v !== targetVersion)
      .map(
        ([pkgName, installedVersion]) =>
          `- \`${pkgName}\` (installed: **${installedVersion}**, required: **${targetVersion}**)`
      )
      .join('\n');

    // Error message template
    const errorMessage = `
🚨 Version Mismatch Error

One or more \`@dynamic-labs-sdk\` packages are installed with mismatched versions. All \`@dynamic-labs-sdk\` packages must be on the same version to work correctly.

Affected Packages:
${affectedPackages}

💡 To fix this issue, update all @dynamic-labs-sdk/* packages to version \`${targetVersion}\` in your package.json
`;

    super(errorMessage.trim());

    this.name = 'VersionMismatchError';
  }
}
